import { useEffect, useState } from "react";

import { useLoaderData } from "react-router";

import { Button } from "@components/Button";
import { Image } from "@components/Image";

import { TSessionData } from "@storage/session/types";
import { userAuthDataStorage } from "@storage/sessionStorage";

import { ICON_PATHS } from "@configs/icons";

export const ToggleSound = () => {
	const [mute, setMute] = useState(false);
	const { currentAccount } = useLoaderData<TSessionData>();

	useEffect(() => {
		setMute(currentAccount.app_mute);
	}, []);

	const handleSound = () => {
		userAuthDataStorage.setItemAsJson({ ...currentAccount, app_mute: !mute });
		setMute((state) => !state);
	};

	return (
		<div className="flex h-10 w-10 items-center justify-center">
			<Button
				onClick={handleSound}
				type="block"
				shape="circle"
				className="h-10 w-10"
				icon={
					!mute ? (
						<Image src={ICON_PATHS.SOUND_ON} alt="soundOn" height={20} width={20} />
					) : (
						<Image src={ICON_PATHS.SOUND_OFF} alt="soundOff" height={20} width={20} />
					)
				}
			/>
		</div>
	);
};
